import config from '@app/config';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { HSBCEuroFormDetails } from './HSBCEuroAfterForm';

export const IPSHSBCEuroAfterForm: InstructionFormDetails = {
  ...HSBCEuroFormDetails,
  downloadLink: `${config.supplierValidationAttachmentsUrl}IPSHSBCEUR/en/hsbc-sepa-ips.pdf`,
};
